import { memo } from 'react';
import useStockAtLocation from '../queries/useStockAtLocation';
import StockIndicator from './StockIndicator';

const StockIndicatorWithData = ({
    sku,
    desiredQuantity = 1,
    branchName,
    location,
    messageStyle,
    lineIndicator = false,
    hideBranchesWithoutAvailability = false,
    hideBranchCode = false,
    skipLoadingStocks,
    isSecondaryBranch = false,
    quantityToIgnore = 0,
}: {
    sku: string;
    desiredQuantity?: number;
    branchName: string;
    location: string;
    messageStyle: 'left' | 'right' | 'tooltip' | 'none';
    lineIndicator?: boolean;
    hideBranchesWithoutAvailability?: boolean;
    hideBranchCode?: boolean;
    skipLoadingStocks?: boolean;
    isSecondaryBranch?: boolean;
    quantityToIgnore?: number;
}) => {
    const { stock, futureStock, restriction, loading } = useStockAtLocation({
        sku,
        location,
        skipLoadingStocks,
    });

    return (
        <StockIndicator
            desiredQuantity={desiredQuantity}
            branchName={branchName}
            location={location}
            messageStyle={messageStyle}
            lineIndicator={lineIndicator}
            hideBranchesWithoutAvailability={hideBranchesWithoutAvailability}
            hideBranchCode={hideBranchCode}
            isSecondaryBranch={isSecondaryBranch}
            stock={stock}
            futureStock={futureStock}
            restriction={restriction}
            loading={loading}
            quantityToIgnore={quantityToIgnore}
        />
    );
};

export default memo(StockIndicatorWithData);
